export default {
    appointments: null,
    appointment: [],
    selectedAppointment: null,
    editedAppointment: null,
    selectedAdmission: null,
    appointmentState: ['appointed', 'admitted', 'entered', 'exited'],
    forceReload: false,
    date: {
        hour: null,
        selected: null,
        week: [],
        period: {
            to: null,
            from: null
        }
    }
};
